import React from "react";
import PropTypes from "prop-types";

import ViewCopyLink from "./ViewCopyLink";

class SyncMySchedule extends React.Component {
  state = { visible: false };

  get url() {
    return `https://digiquatics.com/my_schedule_calendar_sync/${
      this.props.userHas
    }.ics`;
  }

  render() {
    return (
      <div>
        <div className="text-right">
          <button
            className="btn btn-long btn-default btn-pink"
            onClick={this.handlerToggle}
          >
            CALENDAR SYNC
          </button>
        </div>

        <ViewCopyLink
          url={this.url}
          visible={this.state.visible}
          onClose={this.handlerToggle}
          onDone={this.handlerLinkCopied}
        />
      </div>
    );
  }

  handlerToggle = () => this.setState({ visible: !this.state.visible });

  handlerLinkCopied = () => {
    toastr.success("Link copied to clipboard");
    this.handlerToggle();
  };
}

SyncMySchedule.propTypes = {
  userHas: PropTypes.string
};

export default SyncMySchedule;
